import { createAction } from 'redux-actions';
import { authFetch, authUpload } from '../AuthFetch';

export const changeFitting1OrderId = createAction('CHANGE_FITTING1_ORDERID');
export const changeFitting1EventKey = createAction('CHANGE_FITTING1_EVENT_KEY');

export const changeOrderDetailBespokeValue = createAction('CHANGE_ORDER_DETAIL_BESPOKE_VALUE');

export const clearFitting1Data = createAction('CLEAR_FITTING1_DATA');
export const clearFitting1Alert = createAction('CLEAR_FITTING1_ALERT');

export const changeOrderAppCheckValue = createAction('CHANGE_ORDER_APP_CHECK_VALUE');
export const changeShowAppCheckDiv = createAction('CHANGE_SHOW_APPCHECK_DEV');
export const clearOrderAppCheckData = createAction('CLEAR_ORDER_APPCHECK_DATA');

export const exportFittingAppData = (payload) => (
    (dispatch) => {
        let url = '/firefighter/fitting1/exportData/' + payload.orderId;

        authFetch('GET', url, null, (json) => {
            dispatch({
                type: 'EXPORT_FITTING_APP_DATA',
                payload: json
            });
        });
    }
);

export const findOrderDetailBespokeList = (payload) => (
    (dispatch) => {
        let url = '/firefighter/orders/' + payload.orderId + '/orderDetails';
        authFetch('GET', url, null, (json) => {
            dispatch({
                type: 'FIND_ORDER_DETAIL_BESPOKE_LIST',
                payload: json
            });
        });
    }
);

export const findOrderDetailBespoke = (pk) => (
    (dispatch) => {
        let url = '/firefighter/fitting1/' + pk.order_id + '/orderDetails/' + pk.order_detail_id;
        authFetch('GET', url, null, (json) => {
            dispatch({
                type: 'FIND_ORDER_DETAIL_BESPOKE',
                payload: json
            });
        });
    }
);

export const editOrderDetailBespoke = (orderDetail) => (
    (dispatch) => {
        let url = '/firefighter/fitting1/' + orderDetail.orderId + '/orderDetails';
        authFetch('POST', url, JSON.stringify(orderDetail), (json) => {
            dispatch({
                type: 'EDIT_ORDER_DETAIL_BESPOKE',
                payload: json
            });
            if (orderDetail.get('orderId')) {
                dispatch(findOrderDetailBespokeList({ orderId: orderDetail.get('orderId') }));
            }
        });
    }
);

export const uploadOrdererAppData = (payload, uploadFile) => (
    (dispatch) => {
        let orderId = payload.orderId;
        if (orderId && !('' === orderId)) {
            let formData = new FormData();
            formData.append('uploadfile', uploadFile);

            dispatch({
                type: 'BEFORE_UPLOAD_ORDERER_APP_DATA'
            });

            let url = '/firefighter/fitting1/' + orderId + '/uploadOrdererData';
            authUpload('POST', url, formData, (json) => {
                dispatch({
                    type: 'AFTER_UPLOAD_ORDERER_APP_DATA',
                    payload: json
                });
            });
        } else {
            let url = '/firefighter/fitting/defaultValidateFail';
            let payload = { displayMessage: '驗證失敗:訂單編號不存在' };
            authFetch('PUT', url, JSON.stringify(payload), (json) => {
                dispatch({
                    type: 'FITTING_DEFAULT_VALIDATE_FAIL',
                    payload: json
                });
            });
        }
    }
);

export const deleteFittingAppRecordByDuration = (payload) => (
    (dispatch) => {
        let orderId = payload.orderId;
        let duration = payload.duration;
        let type = payload.type;
        if (orderId && !('' === orderId)) {
            let url = '/firefighter/fitting1/' + orderId + '/deleteFittingRecordByDuration/' + duration + '/' + type;
            authUpload('DELETE', url, JSON.stringify(payload), (json) => {
                dispatch({
                    type: 'DELETE_BY_DURATION',
                    payload: json
                });
            });
        } else {
            let url = '/firefighter/fitting/defaultValidateFail';
            let payload = { displayMessage: '驗證失敗:訂單編號不存在' };
            authFetch('PUT', url, JSON.stringify(payload), (json) => {
                dispatch({
                    type: 'FITTING_DEFAULT_VALIDATE_FAIL',
                    payload: json
                });
            });
        }
    }
);

export const findOrderAppCheckList = (payload) => (
    (dispatch) => {
        // console.log(payload);
        let url = '/firefighter/fitting1/' + payload.orderId + '/orderAppCheck';
        authFetch('GET', url, null, (json) => {
            dispatch({
                type: 'FIND_ORDER_APPCHECK_LIST',
                payload: json
            });
        });
    }
);

export const findOrderAppCheck = (payload) => (
    (dispatch) => {
        // console.log(payload);
        let url = '/firefighter/fitting1/' + payload.orderId + '/orderAppCheck/' + payload.checkId;
        authFetch('GET', url, null, (json) => {
            dispatch({
                type: 'FIND_ORDER_APPCHECK',
                payload: json
            });
        });
    }
);

export const editOrderAppCheck = (payload) => (
    (dispatch) => {
        let url = '/firefighter/fitting1/' + payload.orderId + '/orderAppCheck/' + payload.checkId;
        authFetch('PUT', url, JSON.stringify(payload), (json) => {
            dispatch({
                type: 'EDIT_ORDER_APPCHECK',
                payload: json
            });
            dispatch(findOrderAppCheckList({ orderId: payload.get('orderId') }));
        });
    }
);

export const addOrderAppCheck = (payload) => (
    (dispatch) => {
        let url = '/firefighter/fitting1/' + payload.orderId + '/orderAppCheck';
        authFetch('POST', url, JSON.stringify(payload), (json) => {
            dispatch({
                type: 'ADD_ORDER_APPCHECK',
                payload: json
            });
            dispatch(findOrderAppCheckList({ orderId: payload.get('orderId') }));
        });
    }
);

export const deleteOrderAppCheck = (payload) => (
    (dispatch) => {
        let url = '/firefighter/fitting1/' + payload.orderId + '/orderAppCheck/' + payload.checkId;
        authFetch('DELETE', url, null, (json) => {
            dispatch({
                type: 'DELETE_ORDER_APPCHECK',
                payload: json
            });
            dispatch(findOrderAppCheckList({ orderId: payload.orderId }));
        });
    }
);


// WEBPACK FOOTER //
// ./src/actions/fitting1Actions.js